module.exports = __webpack_public_path__ + "img/marker_five_blue1.1b96a563.png";